import { render, staticRenderFns } from "./ModelBrowserOverlay.vue?vue&type=template&id=134d3f71&scoped=true&"
import script from "./ModelBrowserOverlay.vue?vue&type=script&lang=ts&"
export * from "./ModelBrowserOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./ModelBrowserOverlay.vue?vue&type=style&index=0&id=134d3f71&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134d3f71",
  null
  
)

export default component.exports